import { Chip, Stack, styled } from '@ethings/ui-toolkit';
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC } from 'react';

interface Props {
  'data-testid'?: string;
  tags: string[];
  sx?: SxProps;
}

const StyledStack = styled(Stack)<{ mergedSx?: SxProps }>(({ mergedSx, theme }) => ({
  ...(unstableStyleFunctionSx({ sx: mergedSx, theme } as never) as Record<string, unknown>),
}));

export const Tags: FC<Props> = ({ tags, sx, ...props }) => {
  if (tags.length === 0) {
    return <></>;
  }

  return <StyledStack direction='row' mergedSx={sx} data-testid={props['data-testid'] ?? 'tags-container'} flexWrap='wrap' gap={1}>
    {tags.map((tag, i) => (
      <Chip size='small' key={i} label={tag} data-testid={`tag-${i}`} />
    ))}
  </StyledStack>;
};
